/**
 * Search dialog (inc/search.php), opened by the header search button (.ssf-search-toggle).
 *
 * Empty field: popular searches. From two characters: live results from the REST search endpoint
 * (pages and posts), 200ms after the last key. Up and Down move through the results, Enter opens
 * the highlighted one (or the full results page), Escape or the backdrop closes. The native <dialog>
 * keeps focus inside and makes the page behind it inert; smooth scroll pauses while it is open.
 *
 * @package Sitamaa_Sahayata_Foundation
 */

( function () {
	'use strict';

	var dialog = document.getElementById( 'ssf-search' );
	var toggles = document.querySelectorAll( '.ssf-search-toggle .elementor-button' );

	if ( ! dialog || ! dialog.showModal || document.body.classList.contains( 'elementor-editor-active' ) ) {
		return;
	}

	var form = dialog.querySelector( 'form' );
	var input = dialog.querySelector( 'input[type="search"]' );
	var popular = dialog.querySelector( '.ssf-sd-popular' );
	var list = dialog.querySelector( '.ssf-sd-results' );
	var status = dialog.querySelector( '.ssf-sd-status' );
	var all = dialog.querySelector( '.ssf-sd-all' );
	var allBase = all.getAttribute( 'href' );
	var endpoint = dialog.getAttribute( 'data-rest' );
	var t = window.ssfText || { f: String };
	var types = { page: t.type_page, post: t.type_update };
	var timer = 0;
	var request = null;
	var active = -1;
	var opener = null;

	function decode( html ) {
		return new DOMParser().parseFromString( html, 'text/html' ).documentElement.textContent;
	}

	function options() {
		return list.querySelectorAll( '[role="option"]' );
	}

	function setActive( index ) {
		var items = options();
		active = items.length ? ( index + items.length ) % items.length : -1;
		items.forEach( function ( item, i ) {
			item.setAttribute( 'aria-selected', String( i === active ) );
		} );
		if ( active > -1 ) {
			input.setAttribute( 'aria-activedescendant', items[ active ].id );
			items[ active ].scrollIntoView( { block: 'nearest' } );
		} else {
			input.removeAttribute( 'aria-activedescendant' );
		}
	}

	function render( results, query ) {
		list.textContent = '';
		results.forEach( function ( result, i ) {
			var li = document.createElement( 'li' );
			var link = document.createElement( 'a' );
			var title = document.createElement( 'span' );
			var type = document.createElement( 'span' );
			li.id = 'ssf-sd-option-' + i;
			li.setAttribute( 'role', 'option' );
			li.setAttribute( 'aria-selected', 'false' );
			link.href = result.url;
			link.tabIndex = -1;
			title.className = 'ssf-sd-title';
			title.textContent = decode( result.title );
			type.className = 'ssf-sd-type';
			type.textContent = types[ result.subtype ] || '';
			link.append( title, type );
			li.append( link );
			li.addEventListener( 'mousemove', function () {
				if ( active !== i ) {
					setActive( i );
				}
			} );
			list.append( li );
		} );
		list.hidden = ! results.length;
		input.setAttribute( 'aria-expanded', String( results.length > 0 ) );
		status.textContent = results.length ? ( 1 === results.length ? t.result_1 : t.f( t.result_n, results.length ) ) : t.f( t.search_none, query );
		status.classList.toggle( 'is-empty', ! results.length );
		setActive( -1 );
	}

	function update() {
		var query = input.value.trim();
		all.href = allBase + encodeURIComponent( query );
		window.clearTimeout( timer );
		if ( request ) {
			request.abort();
			request = null;
		}
		if ( query.length < 2 ) {
			popular.hidden = false;
			list.hidden = true;
			list.textContent = '';
			status.textContent = '';
			status.classList.remove( 'is-empty' );
			input.setAttribute( 'aria-expanded', 'false' );
			active = -1;
			return;
		}
		popular.hidden = true;
		timer = window.setTimeout( function () {
			request = new AbortController();
			fetch( endpoint + '?subtype=page,post&per_page=6&search=' + encodeURIComponent( query ), { signal: request.signal } )
				.then( function ( response ) {
					return response.ok ? response.json() : [];
				} )
				.then( function ( results ) {
					render( results, query );
				} )
				.catch( function () {} );
		}, 200 );
	}

	function open( event ) {
		event.preventDefault();
		opener = event.currentTarget;
		dialog.showModal();
		document.documentElement.classList.add( 'ssf-search-open' );
		if ( window.ssfLenis ) {
			window.ssfLenis.stop();
		}
		input.focus();
		input.select();
	}

	dialog.addEventListener( 'close', function () {
		document.documentElement.classList.remove( 'ssf-search-open' );
		if ( window.ssfLenis ) {
			window.ssfLenis.start();
		}
		if ( opener ) {
			opener.focus();
		}
	} );

	toggles.forEach( function ( toggle ) {
		toggle.setAttribute( 'role', 'button' );
		toggle.setAttribute( 'aria-haspopup', 'dialog' );
		toggle.setAttribute( 'aria-controls', dialog.id );
		toggle.addEventListener( 'click', open );
		toggle.addEventListener( 'keydown', function ( event ) {
			if ( ' ' === event.key ) {
				open( event );
			}
		} );
	} );

	// A click on the backdrop lands on the <dialog> itself, outside its content box.
	dialog.addEventListener( 'click', function ( event ) {
		if ( event.target === dialog ) {
			dialog.close();
		}
	} );

	dialog.querySelector( '.ssf-sd-close' ).addEventListener( 'click', function () {
		dialog.close();
	} );

	dialog.querySelectorAll( '.ssf-sd-chip' ).forEach( function ( chip ) {
		chip.addEventListener( 'click', function () {
			input.value = chip.textContent;
			update();
			input.focus();
		} );
	} );

	input.addEventListener( 'input', update );

	input.addEventListener( 'keydown', function ( event ) {
		// A search field spends the first Escape on clearing itself; close the dialog straight away instead.
		if ( 'Escape' === event.key ) {
			event.preventDefault();
			dialog.close();
		} else if ( 'ArrowDown' === event.key || 'ArrowUp' === event.key ) {
			if ( options().length ) {
				event.preventDefault();
				setActive( active + ( 'ArrowDown' === event.key ? 1 : -1 ) );
			}
		}
	} );

	form.addEventListener( 'submit', function ( event ) {
		var items = options();
		if ( active > -1 && items[ active ] ) {
			event.preventDefault();
			window.location.href = items[ active ].querySelector( 'a' ).href;
		} else if ( ! input.value.trim() ) {
			event.preventDefault();
		}
	} );
}() );
